export default __webpack_public_path__ + "static/media/ic-bill.1252d057.svg";